module.exports = __webpack_public_path__ + "img/empty-cart.bece9288.svg";